export default "__VITE_ASSET__OMnXi$IM__"